import { Icon } from '../components/shared/Icons';
import { IntegrationService, UploadMediaType } from '../types';

type UploadMediaDetails = {
  label: string;
  service?: IntegrationService;
  icon?: Icon;
};

export const UPLOAD_MEDIA_TYPE_DETAILS: Record<UploadMediaType, UploadMediaDetails> = {
  [UploadMediaType.FILE]: {
    label: 'Upload media file',
  },
  [UploadMediaType.LINK]: {
    label: 'Share media link',
  },
  [UploadMediaType.GONG_CALL]: {
    label: 'Import from Gong',
    service: IntegrationService.GONG,
    icon: Icon.GONG_LIGHT,
  },
  [UploadMediaType.SALESLOFT_CALL]: {
    label: 'Import from Salesloft',
    service: IntegrationService.SALESLOFT,
    icon: Icon.SALESLOFT_LIGHT,
  },
};
